<template>
  <div class="">
    <h4 class="title is-4"><b-icon icon="newspaper"></b-icon> Latest Post</h4>
    <h5 class="subtitle is-5">{{this.blog.title}}</h5>
    <div v-html="concatBlog(this.blog.body)"></div>
    <router-link :to="blogRoute(this.blog.id)">
      <a class="is-pulled-right">Read more...</a>
    </router-link>
  </div>
</template>

<script>
  import BIcon from "buefy/src/components/icon/Icon";
  import BlogService from "@/service/BlogService"

  export default {
    name: "LatestBlog",
    components: {BIcon},
    data() {
      return {
        blog: {title: '', body: '', id: ''}
      }
    },
    computed: {},
    methods: {
      concatBlog(body) {
        if (body.length > 150) {
          return body.substring(0, 150) + '...'
        }
        return body
      },
      blogRoute(id) {
        return '/blog/post/' + id
      },
      getLatestBlog() {
        //pass in null for token because it doesnt really matter.
        BlogService.getLatestBlog(null).then((response) => {
          this.blog = response.data
        })
      }
    },
    mounted() {
      this.getLatestBlog()
    }
  }
</script>